import React from "react";

import { styled } from "styled-components";

import { SearchPanel } from "shared/ui/filters";
import { AlertDiv, BaseContainer, PageTitle } from "shared/ui/layout";
import { DataTable, Pagination } from "shared/ui/table";

const QUICK_RANGE_OPTIONS = [
  { label: "오늘", value: 0 },
  { label: "1주일", value: 1 },
  { label: "1개월", value: 2 },
  { label: "3개월", value: 3 },
  { label: "6개월", value: 4 },
  { label: "1년", value: 5 },
];

export function CommunicationListLayout({
  pageTitle,
  columns,
  data,
  onRowClick,
  searchConfig,
  onSearchFilters,
  onReset,
  newPostsCount,
  totalCount,
  page,
  setPage,
  itemsPerPage,
}) {
  return (
    <BaseContainer>
      <PageTitle pageName={pageTitle} />
      <SearchPanel onSearch={onSearchFilters} onReset={onReset}>
        <SearchPanel.Keyword
          label="조건 검색"
          dropdown={searchConfig.dropdownOptions}
        />
        <SearchPanel.Chips
          name="status"
          label="처리 상태"
          options={searchConfig.statusOptions}
          deselectTo={searchConfig.defaultSelectedStatus}
        />
        <SearchPanel.QuickRange label="게시 기간" options={QUICK_RANGE_OPTIONS} />
        <SearchPanel.DateRange />
      </SearchPanel>
      <AlertDiv>
        <p>
          [오늘 등록된 새 글 <Count>{newPostsCount}건</Count>] 검색 결과{" "}
          <Count>{totalCount}건</Count> 검색 되었습니다.
        </p>
      </AlertDiv>
      <DataTable columns={columns} data={data} onRowClick={onRowClick} />
      <Pagination
        page={page}
        pageSize={itemsPerPage}
        totalCount={totalCount}
        onPageChange={setPage}
      />
    </BaseContainer>
  );
}

const Count = styled.span`
  color: #0079e0;
  font-weight: bold;
`;
